/* eslint-disable no-param-reassign */
import produce from 'immer';

import { REASON_CODE_DICTIONARY } from './constants';
import { validate } from '../../../utils/validate';

const concurrentFields = {
  confirmEmail: {
    comparison: 'email',
    name: 'Emails',
  },
  confirmPassword: {
    comparison: 'password',
    name: 'Passwords',
  },
};

export const handleNext = (
  {
    dispatchError,
    dispatchNext,
    dispatchResetInputErrors,
    field,
    form,
    formValues,
    handleSubmitStep,
    skipStep = false,
    step,
  },
) => {
  const nextStep = skipStep ? 2 : 1;
  // Handles case where no validation is needed
  if (!field) {
    if (handleSubmitStep) {
      handleSubmitStep();
    } else {
      dispatchNext(step + nextStep);
    }
    return;
  }
  if (Array.isArray(field)) {
    const validatedFields = field.reduce((acc, type) => {
      // Skip and continue reduce iteration if type is 'isChangeEmail'
      if (type === 'isChangeEmail') return acc;
      const concurrentField = concurrentFields[type] || {};
      const value = formValues[type];
      const hasError = validateOne({
        dispatchError,
        form,
        type,
        validationProps: concurrentField ?
          {
            comparisonValue: formValues[concurrentField.comparison],
            name: concurrentField.name,
          } : {},
        value,
      });
      if (hasError) {
        acc = false;
      }
      return acc;
    }, true);
    if (validatedFields) {
      if (handleSubmitStep) {
        handleSubmitStep();
      } else {
        dispatchNext(step + nextStep);
      }
    }
  } else {
    const hasError = validateOne({
      dispatchError,
      form,
      type: field,
      value: formValues[field],
    });
    if (!hasError) {
      dispatchResetInputErrors({ field, form });
      if (handleSubmitStep) {
        handleSubmitStep();
      } else {
        dispatchNext(step + nextStep);
      }
    }
  }
};

export const parseReasonCodes = (apiReasons, defaultErrors) =>
  produce(defaultErrors, (draft) => {
    const reasons = apiReasons || [];
    reasons.forEach((reasonCode) => {
      if (REASON_CODE_DICTIONARY[reasonCode]) {
        const { key, message = true } = REASON_CODE_DICTIONARY[reasonCode];
        if (key === 'bannerError' && Array.isArray(draft.bannerError)) {
          draft.bannerError.push(message);
        } else {
          draft[key] = message;
        }
      }
    });
  });

const validateOne = ({
  dispatchError,
  form,
  type,
  validationProps,
  value,
}) => {
  const error = validate({
    required: true,
    type: concurrentFields[type] ? 'concurrentFields' : type,
    value,
    ...validationProps,
  });
  if (error) {
    const { message } = error;
    dispatchError({
      field: type,
      form,
      value: message,
    });
    return true;
  }
  dispatchError({
    field: type,
    form,
    value: '',
  });
  return false;
};
